<template lang="html">
	<div class="common-mar-b">
		<van-row class="buy-container">
			<van-col span="24">
				<div class="buy-item" v-for="(item, index) in buies" :key="index" @click="goDetail(item)">
					<div class="buy-item-image">
						<van-image class="video-list-image" fit="cover" :src="imgUrl + item.course_thumbnail_image" />
					</div>
					<div class="buy-item-info">
						<div>
							<div class="buy-item-title">{{item.course_title}}</div>
							<div class="buy-item-time">购买时间：{{item.addtime}}</div>
						</div>
					</div>
				</div>
			</van-col>
		</van-row>
		<van-row class="buy-container nobuy-container" :class="{'show': buies.length == 0}">
			<van-col span="24">
				<div><van-image class="nobuy" fit="cover" src="../../../static/images/wuyigou.png" /></div>
				<div class="nobuy-text">空空如也</div>
			</van-col>
		</van-row>
		<footer-nav></footer-nav>
	</div>
</template>

<script>
	import FooterNav from "../../components/footer.vue"
	export default{
		components:{
			FooterNav
		},
		data(){
			return{
				imgUrl: 'http://sls.zhishen.net.cn', //图片拼接路径
				buies: [],
				isLoading: false, //控制下拉刷新的加载动画
				loading: false,//控制上拉加载的加载动画
				finished: false,//控制在页面往下移动到底部时是否调用接口获取数据
				totalPage: 0,
				pageNumber: 0
			}
		},
		created(){
			document.title = "已购";
			let that = this;
			// 百度统计
			let _hmt = _hmt || [];
			(function() {
			  //每次执行前，先移除上次插入的代码
			  document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
			  let hm = document.createElement("script");
			  hm.src = "https://hm.baidu.com/hm.js?5bf14d717bf0afb01060aea203da42c2";
			  hm.id = "baidu_tj";
			  let s = document.getElementsByTagName("script")[0]; 
			  s.parentNode.insertBefore(hm, s);
			})();
			let formdata = new FormData();
			formdata.append('token', localStorage.getItem('token'));
			formdata.append('user_id', localStorage.getItem('userId'));
			formdata.append('page', 0);
			that.$axios.post('http://sls.zhishen.net.cn/api/Usercourse/userCourseIndex', formdata).then(function (res) {
				res.data.user_course.forEach(function(item){
					that.buies.push({
						'course_thumbnail_image': item.course_thumbnail_image,
						'course_title': item.course_title,
						'addtime': that.timestampToTime(item.addtime),
						'id': item.id,
						'type': item.type
					})
				})
			})
			.catch(function (error) {
				console.log(error);
			});
		},
		methods:{
			//点击跳转课程详情
			goDetail(order){
				let that = this
				if(order.type == 1){
					window.location.href = that.login.pageUrl + '/coursedetail?courseId=' + order.id; //课程详情
				}
				if(order.type == 2){
					window.location.href = that.login.pageUrl + '/onlivedetail?liveId=' + order.id; //直播详情
				}
			},
			timestampToTime(timestamp) {
				var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
				var Y = date.getFullYear() + '年';
				var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '月';
				var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + '日 ';
				var h = date.getHours() + ':';
				var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
				var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
				return Y+M+D+h+m+s;
			}
		}
	}
</script>

<style lang="css" scoped>
	.buy-container{width: 89.34vw;margin: 0 auto;}
	.buy-container .van-col .buy-item:last-child{border-bottom: none;}
	.buy-item{width: 100%;height: 21.34vw;padding: 5.34vw 0;border-bottom: 1px solid #f1f1f1;display: flex;flex-direction: row;}
	.buy-item-image{margin-right: 4vw;}
	.buy-item-image,.video-list-image{width: 21.34vw;height: 100%;}
	.buy-item-info{width: calc(100% - 25.34vw);height: 100%;display: table;}
	.buy-item-info > div{display: table-cell;vertical-align: middle;}
	.buy-item-title,.buy-item-time{width: 100%;}
	.buy-item-title{line-height: 6.13vw;}
	.buy-item-time{color: #666;font-size: 3.47vw;line-height: 3.47vw;height: 3.47vw;margin-top: 4vw;}
	.nobuy-container{display: none;padding-top: 44vw;}
	.nobuy{width: 48vw;margin: 0 20.67vw;}
	.nobuy-text{color: #999;font-size: 4vw;margin-top: 5.33vw;text-align: center;}
	.show{display: block;}
</style>



// WEBPACK FOOTER //
// src/view/buy/index.vue